module.exports = __webpack_public_path__ + "img/Reports.5721e92f.svg";